import getNested from '../getNested';
import { User } from '../../types/user';
import max from 'lodash/max';
import reduce from 'lodash/reduce';
import { Service, ServiceGroup } from '../../types/service';

export function getPartnerInfo(salonId: number) {
  if (salonId) {
    const partners = {
      49978: {
        name: 'Garden Grove',
        address: '10121 Westminster Ave, Garden Grove, CA 92843',
        logo: 'https://advancebeautycollege.com/wp-content/uploads/2018/10/ABC-Logo_high-res_no-fade.png',
      },
      49979: {
        name: 'Laguna Hills',
        address: '25332 McIntyre Street, Laguna Hills, CA 92653',
        logo: 'https://advancebeautycollege.com/wp-content/uploads/2018/10/ABC-Logo_high-res_no-fade.png',
      },
    };

    return partners[salonId];
  }

  return null;
};


export function extractServices(serviceGroups: ServiceGroup[] = []) {
  let services = [];

  serviceGroups.forEach(group => {
    (group.data || []).forEach(cate => {
      services = services.concat(cate.data || []);
    });
  })

  return services;
}


export function countSelectedServices(user: User, cate: any): number {
  const userServices = getNested(user, 'selectedServices', [] as any);
  const selectedServices = userServices.filter(service => {
    return cate.type === 'category'
      ? service.categoryKey === cate.key
      : service.subCategoryKey === cate.key
      ;
  });
  return selectedServices.length;
}


export function getUserFullName(user: User) {
  return [user.firstName, user.lastName]
    .filter(field => !!field)
    .join(' ')
    ;
}


function getUserDuration(user: User) {
  const userServices = getNested(user, 'selectedServices', [] as any) || [];

  if (userServices.length > 0) {
    return reduce(userServices, (sum: number, service: Service) => {
      return sum + service.duration;
    }, 0);
  }

  return 0;
}

export function getBookingDuration(users: User[]) {
  const userDurations = users.map(getUserDuration);
  return max(userDurations);
}
